import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './navbar.scss'
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import Tooltip from '@mui/material/Tooltip';
import { AYUDA_LINK, OFERTA_LINK, PERFIL_LINK, SALIR_LINK } from '../../helpers/enlacesNavBar';
import { useLocation } from 'react-router-dom';
import { useUsuario } from '../../context/usuarioContext';

const Navbar = ({ navSelectedItem, setNavSelectedItem, setSelectedItem, setSelectedItemNoExpanded, setSubSelectedItem, expandedItems, setExpandedItems, setShowMenu}) => {
  const isMobile = window.innerWidth <= 768;
  // const [navSelectedItem, setNavSelectedItem] = useState('');
  const { logout } = useUsuario();

  const handleItemNavClick = (subItem) => {
    setSelectedItem('');
    setSelectedItemNoExpanded('');
    setSubSelectedItem('');
    if(setShowMenu){
      setShowMenu(false);
    }
    
    setExpandedItems({
      boleta: false,
      plan: false,
      solicitud: false,
    })
    setNavSelectedItem(subItem)
    if(subItem == 'salir'){
      logout()
    }
    setShowMenu(false)
  };

  const location = useLocation();

  useEffect(() => {
    const urlParts = location.pathname.split('/');
    const lastUrlPart = urlParts[urlParts.length - 1];

    if (lastUrlPart) {
      setNavSelectedItem(lastUrlPart)
    }

    // if (lastUrlPart == 'boletas' || lastUrlPart == 'pagos') {
    //   setSelectedItem('boleta')
    //   setSubSelectedItem(lastUrlPart)
    // }

    // if (lastUrlPart == 'internet' || lastUrlPart == 'movil') {
    //   setSelectedItem('plan')
    //   setSubSelectedItem(lastUrlPart)
    // }

    // if (lastUrlPart == 'realizar-solicitud' || lastUrlPart == 'solicitudes-tecnicas' || lastUrlPart == 'solicitudes-comerciales' || lastUrlPart == 'reagendar-visita' ) {
    //   setSelectedItem('solicitud')
    //   setSubSelectedItem(lastUrlPart)
    // }

    // if (lastUrlPart == 'resume' || lastUrlPart == 'mundo-go' || lastUrlPart == 'sugerencias') {
    //   setSelectedItemNoExpanded(lastUrlPart)
    // }

    // if (lastUrlPart == '') {
    //   setSelectedItemNoExpanded('resume')
    // }
  }, [location]);

  return (
    <nav className='navbar__content'>
      <ul>
        {/* <li>
          {isMobile ? (
            <CardGiftcardOutlinedIcon />
          ) : (
            <Tooltip title="Oferta" placement="bottom">
              <CardGiftcardOutlinedIcon />
            </Tooltip>
          )}
          <span className='navbar__content__nombre'>Oferta</span>
        </li> */}
        {/* <li className={`navbar__item ${navSelectedItem === 'oferta' ? 'selected' : ''}`}>
          <Link onClick={() => handleItemNavClick('oferta')} to={OFERTA_LINK}>
            {isMobile ? (
              <CardGiftcardOutlinedIcon />
            ) : (
              <Tooltip title="Oferta" placement="bottom">
                <CardGiftcardOutlinedIcon />
              </Tooltip>
            )}
            <span className='navbar__content__nombre'>Oferta</span>
          </Link>
        </li> */}
        {/* <li>
          {isMobile ? (
            <HelpOutlineOutlinedIcon />
          ) : (
            <Tooltip title="Ayuda" placement="bottom">
              <HelpOutlineOutlinedIcon />
            </Tooltip>
          )}
          <span className='navbar__content__nombre'>Ayuda</span>
        </li> */}
        <li className={`navbar__item ${navSelectedItem === 'ayuda' ? 'selected' : ''}`}>
          <a href="https://tumundo.cl/centro-de-ayuda/" target="_blank">
            {isMobile ? (
              <HelpOutlineOutlinedIcon />
            ) : (
              <Tooltip title="Ayuda" placement="bottom">
                <HelpOutlineOutlinedIcon />
              </Tooltip>
            )}
            <span className='navbar__content__nombre'>Ayuda</span>
          </a>
        </li>

        <li className={`navbar__item ${navSelectedItem === 'perfil' ? 'selected' : ''}`}>
          <Link onClick={() => handleItemNavClick('perfil')} to={PERFIL_LINK}>
            {isMobile ? (
              <AccountCircleOutlinedIcon />
            ) : (
              <Tooltip title="Perfil" placement="bottom">
                <AccountCircleOutlinedIcon />
              </Tooltip>
            )}
            <span className='navbar__content__nombre'>Perfil</span>
          </Link>
        </li>
        {/* <li>
          {isMobile ? (
            <LoginOutlinedIcon />
          ) : (
            <Tooltip title="Salir" placement="bottom">
              <LoginOutlinedIcon />
            </Tooltip>
          )}
          <span className='navbar__content__nombre'>Salir</span>
        </li> */}
        <li className={`navbar__item ${navSelectedItem === 'salir' ? 'selected' : ''}`}>
          <Link onClick={() => handleItemNavClick('salir')} >
            {isMobile ? (
              <LoginOutlinedIcon />
            ) : (
              <Tooltip title="Salir" placement="bottom">
                <LoginOutlinedIcon />
              </Tooltip>
            )}
            <span className='navbar__content__nombre'>Salir</span>
          </Link>
        </li>
      </ul>
    </nav>
  )
}

export default Navbar